import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { IllamLogo, IllamAppIcon } from "@/components/IllamLogo";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F5F2EB]">
      {/* Left: form */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm animate-fade-up">
          <IllamLogo className="mb-8" subtitle />
          <h1 className="font-heading text-2xl font-bold tracking-tight text-neutral-900">Sign in to ILLAM</h1>
          <p className="text-sm text-neutral-500 mt-1 mb-8">Interior Design & Execution Operating System</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-medium text-neutral-600 uppercase tracking-wider">Email</label>
              <input
                data-testid="login-email-input"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="mt-1.5 w-full rounded-md border border-[#D7C6A9] bg-white px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#F56B1F] focus:border-transparent transition"
                placeholder="you@illam.in"
              />
            </div>
            <div>
              <label className="text-xs font-medium text-neutral-600 uppercase tracking-wider">Password</label>
              <input
                data-testid="login-password-input"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="mt-1.5 w-full rounded-md border border-[#D7C6A9] bg-white px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#F56B1F] focus:border-transparent transition"
                placeholder="••••••••"
              />
            </div>
            {error && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
            <button
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 rounded-md bg-[#F56B1F] hover:bg-[#D65A10] text-white font-medium text-sm py-2.5 transition-colors shadow-sm disabled:opacity-60"
            >
              {loading && <Loader2 size={16} className="animate-spin" />} Sign in
            </button>
          </form>
          <p className="text-xs text-neutral-400 mt-6 mono">Founder demo · vigneshjeevanandhan1995@gmail.com</p>
        </div>
      </div>
      {/* Right: brand panel */}
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#3E3E3E] text-[#F5F2EB] relative overflow-hidden">
        <IllamLogo dark size="lg" className="self-start" />
        <div className="relative z-10">
          <IllamAppIcon size={68} />
          <h2 className="font-heading text-4xl font-extrabold leading-tight tracking-tight mt-8">
            Spaces for a<br />better tomorrow.
          </h2>
          <p className="text-[#b9b3a6] mt-4 max-w-sm text-sm leading-relaxed">
            One operating system for interior design & execution — leads to design, procurement, execution, finance and warranty. AI-native. Built for Tamil Nadu, scaling everywhere.
          </p>
          <div className="flex gap-6 mt-10">
            {["DESIGN", "PLAN", "EXECUTE", "LIVE"].map((s, i) => (
              <div key={s} className="text-xs uppercase tracking-widest" style={{ color: i === 0 ? "#F56B1F" : "#8a8a8a" }}>{s}</div>
            ))}
          </div>
        </div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#F56B1F] opacity-[0.07] blur-2xl" />
        <div className="text-xs text-[#6b6b6b]">© {new Date().getFullYear()} ILLAM · Multi-tenant SaaS</div>
      </div>
    </div>
  );
}
